import script from "./Pla01CancelamentoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./Pla01CancelamentoPage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__